import React from 'react';
import { useTranslation } from 'react-i18next';

import setSidebarActiveTabByNameOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabByNameOperation';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import { DEFAULT_TEXT_LIBRARY_TITLE_KEY } from 'editor/src/component/DesktopSidebar/TabContents/TextLibraryTabContent/constants';
import IconTextLibrary from 'editor/src/component/Icon/IconTextLibrary';
import MenuButton from 'editor/src/component/TopMenuDesktop/buttons/MenuButton';

/**
 * On mobile a selected text swaps the tab bar for text tools, which would hide the library tab
 * exactly when "Add to selected text" applies. Opens the library sheet with the text still selected.
 */
function ButtonTextLibrary() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const title = useSelector((state) => state.editorModules.textLibrary.title);
  const hasEntries = useSelector((state) => state.editorModules.textLibrary.entries.length > 0);

  if (!hasEntries) {
    return null;
  }

  return (
    <MenuButton
      Icon={IconTextLibrary}
      mode="label-icon-vertical"
      label={title || t(DEFAULT_TEXT_LIBRARY_TITLE_KEY)}
      handleClick={() => dispatch(setSidebarActiveTabByNameOperation(TAB_NAMES.TEXT_LIBRARY))}
      className="cy-button-text-library"
    />
  );
}

export default React.memo(ButtonTextLibrary);
